import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
// Initialize third-party scripts early (before React loads)
// These are processed by Vite, so import.meta.env values are replaced at build time
import './utils/gtag-init.js'
import './utils/adsense-init.js'
import './utils/google-maps-init.js'

ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
) 